module.exports = __webpack_public_path__ + "img/小蜡笔@2x.8079a2e9.png";